import styled from 'styled-components';

import { TBaseSVG } from '@/shared/assets/icons/base-icon/base-icon.types';

export const BaseSVG = styled.svg<TBaseSVG>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ $color }) => $color || 'inherit'};
  ${({ $size }) =>
    $size &&
    `width: ${$size} !important; height: ${$size} !important; min-width: ${$size} !important; min-height: ${$size} !important;`}
`;
